export default {
    methods: {
        clearAndCapitalize (str) {
            if (['ped', 'peb'].includes(str)) return str.toUpperCase()
            const words = str.split("_")

            for (let i = 0; i < words.length; i++) {
                if(words[i][0] !== undefined)
                {
                    words[i] = words[i][0].toUpperCase() + words[i].substr(1)
                }
            }

            return words.join(" ")
        },
        wrapText(text, limit = 20) {
            if (Array.isArray(text)) return text;
            if (text.length <= limit) return text;
            const words = text.split(' ');
            const lines = [];
            let currentLine = '';

            words.forEach(word => {
                if ((currentLine + word).length <= limit) {
                    currentLine += (currentLine === '' ? '' : ' ') + word;
                } else {
                    if (currentLine !== '') lines.push(currentLine);
                    currentLine = word;
                }
            });
            if (currentLine !== '') lines.push(currentLine);
            return lines;
        },
        capitalize (str) {
            if (['ped', 'peb'].includes(str)) return str.toUpperCase()
            return str.charAt(0).toUpperCase() + str.slice(1)
        },
        isEmptyString (str) {
            return (str === null || str === "")
        },
        dateWithoutTime(date) {
            return `${date.getDate()}/${date.getMonth()}/${date.getFullYear()}`
        }
    }
};
